function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("path", {
  fill: "#D97E7E",
  fillRule: "evenodd",
  d: "M13.78 10.929c.624 1.106-.156 2.488-1.405 2.488H1.625c-1.249 0-2.03-1.382-1.405-2.488l5.375-9.516c.625-1.106 2.186-1.106 2.81 0l5.376 9.516zM6.11 4.975c0-.493.398-.891.89-.891.493 0 .892.398.892.89v2.757c0 .492-.4.89-.891.89-.493 0-.892-.398-.892-.89V4.975zM7 11.084c.493 0 .892-.4.892-.892s-.4-.89-.891-.89c-.493 0-.892.398-.892.89s.4.892.892.892z",
  clipRule: "evenodd"
});

var SvgExclamationTriangleFill = function SvgExclamationTriangleFill(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgExclamationTriangleFill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/exclamation-triangle-fill.72b0ef98.svg";
export { ForwardRef as ReactComponent };